<div class="footer">
    <span class="footer-left">
        cloudServe
    </span>
</div>
